<template>
  <div class="app-container">
    <el-descriptions title="车场信息" direction="vertical" :column="2" border>
      <el-descriptions-item label="总车位数">{{
        infoForm.totalParkingSpaceNum || "--"
      }}</el-descriptions-item>
      <el-descriptions-item label="剩余车位数">{{
        infoForm.leftParkingSpaceNum || "0"
      }}</el-descriptions-item>
      <el-descriptions-item label="出入口信息" :span="2">
        <el-table :data="infoForm.gateInfos" style="width: 100%" border>
          <el-table-column prop="gateName" label="出入口名称">
          </el-table-column>
          <el-table-column prop="laneNum" label="车道数量"> </el-table-column>
        </el-table>
      </el-descriptions-item>
      <el-descriptions-item label="车道信息" :span="2">
        <el-table :data="infoForm.laneInfos" style="width: 100%" border>
          <el-table-column prop="gateName" label="车道名称"> </el-table-column>
          <el-table-column prop="laneNum" label="车道编号"> </el-table-column>
          <el-table-column prop="laneType" label="车道方向">
            <template slot-scope="scope">
              {{
                scope.row.laneType == 1
                  ? "出场车道"
                  : scope.row.laneType == 2
                  ? "出入车道"
                  : "入口"
              }}
            </template>
          </el-table-column>
        </el-table>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import { get_car_site } from "@/api/parking";
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      ossUpload: this.$store.state.ossUpload,
      uploadUrl: this.$store.state.baseURL,
      infoForm: {}, // 正在上传的图片
      loading: false,
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      get_car_site().then((res) => {
        console.log(res);
        this.infoForm = res.data.info;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container {
  padding: 60px;
}
::v-deep .el-upload-list {
  display: none;
}
</style>
